const MAX_STORED_ADDRESSES = 5;

const storageKey = (walletId: string) => `wallet_onchain_addresses_${walletId}`;

function readUsedAddresses(walletId: string): string[] {
  const raw = localStorage.getItem(storageKey(walletId));
  if (!raw) {
    return [];
  }

  try {
    const parsed = JSON.parse(raw) as string[];
    if (!Array.isArray(parsed)) {
      return [];
    }
    return parsed
      .map((address) => address.trim())
      .filter((address) => address.length > 0);
  } catch {
    return [];
  }
}

function writeUsedAddresses(walletId: string, addresses: string[]): void {
  localStorage.setItem(storageKey(walletId), JSON.stringify(addresses));
}

export function getStoredOnchainAddresses(walletId: string): string[] {
  const normalizedWalletId = walletId.trim();
  if (!normalizedWalletId) {
    return [];
  }

  return readUsedAddresses(normalizedWalletId).filter(
    (address, index, addresses) => addresses.indexOf(address) === index,
  );
}

export function isStoredOnchainAddressUsed(walletId: string, address: string): boolean {
  const normalizedWalletId = walletId.trim();
  const normalizedAddress = address.trim();
  if (!normalizedWalletId || !normalizedAddress) {
    return false;
  }

  return getStoredOnchainAddresses(normalizedWalletId).includes(normalizedAddress);
}

export function storeUsedOnchainAddress(walletId: string, address: string): void {
  const normalizedWalletId = walletId.trim();
  const normalizedAddress = address.trim();
  if (!normalizedWalletId || !normalizedAddress) {
    return;
  }

  const withoutCurrent = readUsedAddresses(normalizedWalletId).filter(
    (storedAddress) => storedAddress !== normalizedAddress,
  );
  const updated = [normalizedAddress, ...withoutCurrent].slice(0, MAX_STORED_ADDRESSES);

  writeUsedAddresses(normalizedWalletId, updated);
}
